import angular from 'angular';

import '../../services/cart';

angular.module('folkeuni').component('serviceLogin', {
  transclude: true,
  template: '<p>Data er gemt</p>',
  controller: function(Cart) {
    var $ctrl = this;

    function getParameterByName(name, url) {
        if (!url) url = window.location.href;
        name = name.replace(/[\[\]]/g, "\\$&");
        var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
            results = regex.exec(url);
        if (!results) return null;
        if (!results[2]) return '';
        return decodeURIComponent(results[2].replace(/\+/g, " "));
    }

    $ctrl.$onInit = function() {
      var item = {
        company: {
          name: getParameterByName("company"),
          cvr: getParameterByName("cvr"),
          ean: getParameterByName("ean"),
          reference: getParameterByName("reference"),
          konteringsnummer: getParameterByName("kontering"),
          address: getParameterByName("cAddress"),
          postalCode: getParameterByName("cPostalCode"),
          city: getParameterByName("cCity"),
          rek: getParameterByName("rekvi")
        },
        customer: {
          firstName: getParameterByName("firstName"),
          middleName: getParameterByName("middleName"),
          lastName: getParameterByName("lastName"),
          email: getParameterByName("email"),
          mobile: Number(getParameterByName("phoneNumber")),
          streetName: getParameterByName("streetName"),
          streetNumber: getParameterByName("streetNumber"),
          floor: getParameterByName("floorNumber"),
          side: getParameterByName("side"),
          roomNumber: getParameterByName("roomNumber"),
          postalCode: Number(getParameterByName("postalCode")),
          city: getParameterByName("city"),
          country: getParameterByName("country")
        }
      };

      Cart.customerInfoLocalStorageSet(item);


    }
  }
});
